import { PromoListItem } from "@/core/entities/promotion/PromoListItem";
import { AppConfig } from "@/infrastructure/services/config";
import { atom } from "jotai";
import { getEmptyPromotionsFilterInfo, PromotionsFilterInfo } from "./promotionFilter.utils";

const _AppConfig = AppConfig.getInstance();
const PAGINATION_PAGE_LIMIT = _AppConfig.PAGINATION_PAGE_LIMIT;

export interface PromotionDrawerInfo {
  promoEventId?: number;
  promoItem?: PromoListItem | null;
  isPromoDrawerOpen?: boolean;
  nextPrevEnabled?: boolean;
}

const initialPromotionDrawerInfo: PromotionDrawerInfo = {
  promoEventId: undefined,
  promoItem: null,
  isPromoDrawerOpen: false,
  nextPrevEnabled: false,
};

export interface PromotionDrawerNavigationState {
  isFirstItem: boolean;
  isLastItem: boolean;
  isNextPrevEnabled: boolean;
}

const initialPromotionDrawerNavigationState: PromotionDrawerNavigationState = {
  isFirstItem: false,
  isLastItem: false,
  isNextPrevEnabled: false,
};

export const promotionDrawerNavigationAtom = atom<PromotionDrawerNavigationState>(
  initialPromotionDrawerNavigationState
);

export interface PromotionsState {
  isFilterApplied: boolean;
  filterInfo: PromotionsFilterInfo;
  promotions: PromoListItem[];
  isLoading: boolean;
  isRefreshing: boolean;
  error: Error | null;
  totalCount: number;
  currentPage: number;
  pageLimit: number;
}

const initialState: PromotionsState = {
  isFilterApplied: false,
  filterInfo: getEmptyPromotionsFilterInfo(),
  promotions: [],
  isLoading: false,
  isRefreshing: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageLimit: PAGINATION_PAGE_LIMIT,
};

export const promotionsAtom = atom<PromotionsState>(initialState);
export const promotionDrawerInfoAtom = atom<PromotionDrawerInfo>(initialPromotionDrawerInfo);

export const promotionsFilterInfoAtom = atom(get => get(promotionsAtom).filterInfo);
export const isPromotionsFilterAppliedAtom = atom(get => get(promotionsAtom).isFilterApplied);
export const promotionsListAtom = atom(get => get(promotionsAtom).promotions);
export const promotionsIsLoadingAtom = atom(get => get(promotionsAtom).isLoading);
export const promotionsIsRefreshingAtom = atom(get => get(promotionsAtom).isRefreshing);
export const promotionsErrorAtom = atom(get => get(promotionsAtom).error);
export const promotionsTotalCountAtom = atom(get => get(promotionsAtom).totalCount);
export const promotionsCurrentPageAtom = atom(get => get(promotionsAtom).currentPage);
export const promotionsPageLimitAtom = atom(get => get(promotionsAtom).pageLimit);

export const promotionIsFirstItemAtom = atom(get => get(promotionDrawerNavigationAtom).isFirstItem);
export const promotionIsLastItemAtom = atom(get => get(promotionDrawerNavigationAtom).isLastItem);
export const promotionIsNextPrevEnabledAtom = atom(get => get(promotionDrawerNavigationAtom).isNextPrevEnabled);

export type { PromotionsFilterInfo } from "./promotionFilter.utils";
